module.exports = __webpack_public_path__ + "static/img/sence-bg-ipad-1.9c93e7e0.png";